import {ImageType} from '@services/resource/image-type';

export class ImageResource {
  constructor(
    public imageType: ImageType,
    public uri?: string,
    public uuid?: string,
    public id?: string,
    public originId?: string | null,
  ) {}
}
